let ENV = 'staging';
if (window.location.origin.includes('dev')) ENV = 'staging';
else if (window.location.origin.includes('youth.lol')) ENV = 'production';

let CONFIG = {
  staging: {
    DEV: true,
    SCHEME: 'https',
    HOST: 'dev.youth.lol',
    S3: 'https://dvo33f65f5yq5.cloudfront.net/youth/dev',
    CDN: 'https://cdn.youth.lol',
    MID: 'INIpayTest',
    API: 'https://dev-api.youth.lol/api'
  },
  production: {
    DEV: false,
    SCHEME: 'https',
    HOST: 'www.youth.lol',
    S3: 'https://dvo33f65f5yq5.cloudfront.net/youth/prod',
    CDN: 'https://cdn.youth.lol',
    MID: 'youth00001',
    API: 'https://api.youth.lol/api'
  }
};

CONFIG = CONFIG[ENV];

CONFIG.BASE_URL = `${CONFIG.SCHEME}://${CONFIG.HOST}`;

export { CONFIG };
